import { QueryHookOptions, useQuery } from '@apollo/client'
import gql from 'graphql-tag'
import { useShowErrorsPopup } from '@/hooks/useShowErrorsPopup'
import { Query, QueryGetActiveCompaniesArgs } from '@/schemaTypes'
import { companyFragments } from './companyFragments'

const GET_ACTIVE_COMPANIES = gql`
  query getActiveCompanies($opts: CompanyOpts) {
    getActiveCompanies(opts: $opts) {
      _id
      name
      uid
      fibuNumber
      successionCompanyId
      companyCounterId
      companyCounter {
        ...CompanyCountersFragment
      }
      configuration {
        minimumPawnDuration
      }
      headquarter {
        countryCode
      }
    }
  }
  ${companyFragments.companyCounter}
`

type TData = { getActiveCompanies: Query['getActiveCompanies'] }
type TVariables = QueryGetActiveCompaniesArgs

export function useGetActiveCompanies(
  opts: QueryHookOptions<TData, TVariables> = {},
) {
  const queryResult = useQuery<TData, TVariables>(GET_ACTIVE_COMPANIES, {
    fetchPolicy: 'network-only',
    ...opts,
  })

  useShowErrorsPopup(queryResult.error)

  return { queryResult, companies: queryResult.data?.getActiveCompanies || [] }
}
